const ALLOWED_STRATEGIES = ["eager", "idle", "interaction"];

/**
 * Resolves the variation-map load strategy for the A/B harness.
 *
 * Source of truth: App.config.item.variationMapLoadStrategy (plugin config). Overridable per page
 * load via the URL param ?vmap=eager|idle|interaction for testing without a redeploy. Unknown
 * values fall back to "eager" (the legacy load-immediately behaviour).
 *
 * @returns {string} one of "eager" | "idle" | "interaction"
 */
export function resolveVariationMapStrategy()
{
    let strategy = (typeof App !== "undefined" && App.config && App.config.item && App.config.item.variationMapLoadStrategy) || "eager";

    if (typeof window !== "undefined" && window.location && window.location.search)
    {
        const match = window.location.search.match(/[?&]vmap=(eager|idle|interaction)/);

        if (match)
        {
            strategy = match[1];
        }
    }

    if (ALLOWED_STRATEGIES.indexOf(strategy) === -1)
    {
        strategy = "eager";
    }

    return strategy;
}
